/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/mine/mine */
import{getNetworkProvider as e}from"../network/default.mjs";import{Network as t}from"../interface.mjs";var i=async({cashaddr:r,blocks:o})=>e(t.REGTEST).daemonPassthrough("generatetoaddress",[o,r]);export{i as mine};
//# sourceMappingURL=mine.mjs.map